import React from "react";
import { Link, useLocation } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import ReactPixel from "react-facebook-pixel";
import { trackEvent } from "../../../services/events";
import { kirkos_logo_white_yellow } from "../../../assets/images";

type HeaderProps = {
    isSearchActive?: boolean;
};

const Header: React.FC<HeaderProps> = ({ isSearchActive }) => {
    const location = useLocation();
    const isHomePage = location.pathname === "/" || location.pathname === "/apk";

    const handleTrackButtonClick = (buttonName: string) => {
        trackEvent({
            event_name: {
                web: `Kirkos_Home_Page_Header_${buttonName}_Click`,
                app: `Kirkos_Home_Page_Header_${buttonName}_Click_App`,
            },
            event_category: "Header_Link_Click",
            module: "HomePage",
            payload: { button_name: buttonName },
        }).catch(() => { });

        if (process.env.REACT_APP_META_PIXEL_ID) {
            try {
                ReactPixel.track("ButtonClick", {
                    content_name: buttonName,
                    content_category: "Header Links",
                    content_type: "Link Click",
                    value: 0,
                    currency: "AED",
                });
            } catch (_) { }
        }
    };

    return (
        <Navbar
            variant="dark"
            expand="lg"
            sticky="top"
            className="landing-shell__topbar results-navbar px-4 px-xl-5"
        // style={{ position: isSearchActive ? "static" : "absolute", top: 0, width: "100%", zIndex: 1000 }}
        >
            <Navbar.Brand as={Link} to="/" className={isSearchActive ? "results-navbar__brand" : "landing-shell__brand"}>
                <img
                    src={kirkos_logo_white_yellow}
                    alt="Kirkos-Logo"
                    className={isSearchActive ? "results-navbar__brand-logo" : "landing-shell__brand-logo"}
                />
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="offcanvasNavbar-expand-lg" />
            <Navbar.Offcanvas
                id="offcanvasNavbar-expand-lg"
                aria-labelledby="offcanvasNavbarLabel-expand-lg"
                placement="end"
                data-bs-theme="dark"
                style={{
                    backgroundColor: "#12151c",
                }}
            >
                <Offcanvas.Header closeButton closeVariant="white">
                    <Offcanvas.Title id="offcanvasNavbarLabel-expand-lg">
                        <img
                            src={kirkos_logo_white_yellow}
                            alt="Kirkos-Logo"
                            style={{ height: "35px" }}
                        />
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {!isSearchActive ? (
                        <Nav className="results-navbar__links justify-content-end flex-grow-1 pe-3 align-items-center">
                            {!isHomePage && (
                                <Nav.Link as={Link} to="/" className={`results-navbar__link ${location.pathname === '/' ? 'is-active' : ''}`} onClick={() => handleTrackButtonClick("Home")}>
                                    Home
                                </Nav.Link>
                            )}

                            <Nav.Link as={Link} to="/signup" className={`results-navbar__link ${location.pathname === '/signup' ? 'is-active' : ''}`} onClick={() => handleTrackButtonClick("Register")}>Register</Nav.Link>
                            <Nav.Link as={Link} to="/signin" className={`results-navbar__link ${location.pathname === '/signin' ? 'is-active' : ''}`} onClick={() => handleTrackButtonClick("Login")}>Login</Nav.Link>
                            {/* <Nav.Link as={Link} to="/merchantsignup" className={`results-navbar__link ${location.pathname === '/merchantsignup' ? 'is-active' : ''}`}>Become a Merchant</Nav.Link>
                            <Nav.Link as={Link} to="/signinmerchant" className={`results-navbar__link ${location.pathname === '/signinmerchant' ? 'is-active' : ''}`}>
                                Merchant Login
                            </Nav.Link> */}
                            <Nav.Link as={Link} to="/contactus" className={`results-navbar__link ${location.pathname === '/contactus' ? 'is-active' : ''}`} onClick={() => handleTrackButtonClick("Contact_Us")}>Contact Us</Nav.Link>
                        </Nav>
                    ) : (
                        <Nav className="results-navbar__links justify-content-end flex-grow-1 pe-3 align-items-center">
                            <Nav.Link as={Link} to="/" className={`results-navbar__link ${location.pathname === '/' ? 'is-active' : ''}`} onClick={() => handleTrackButtonClick("Home")}>
                                Home
                            </Nav.Link>
                            {/* <Nav.Link as={Link} to="/contactus" className="results-navbar__link">
                                Services
                            </Nav.Link>
                            <Nav.Link as={Link} to="/about" className="results-navbar__link">
                                About
                            </Nav.Link> */}
                            <Nav.Link as={Link} to="/signup" className={`results-navbar__link ${location.pathname === '/signup' ? 'is-active' : ''}`} onClick={() => handleTrackButtonClick("Register")}>
                                Register
                            </Nav.Link>
                            <Nav.Link as={Link} to="/signin" className={`results-navbar__link ${location.pathname === '/signin' ? 'is-active' : ''}`} onClick={() => handleTrackButtonClick("Login")}>
                                Login
                            </Nav.Link>
                            <Nav.Link as={Link} to="/contactus" className={`results-navbar__link ${location.pathname === '/contactus' ? 'is-active' : ''}`} onClick={() => handleTrackButtonClick("Contact_Us")}>
                                Contact Us
                            </Nav.Link>

                        </Nav>
                    )}
                </Offcanvas.Body>
            </Navbar.Offcanvas>
        </Navbar>
    );
};

export default Header;
